import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vcode",
  "use": "icon-vcode-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-vcode\"><defs><style type=\"text/css\"></style></defs><path d=\"M554.368 719.061333V819.2h100.138667a50.048 50.048 0 0 1 0 100.138667H554.368v50.048a50.048 50.048 0 0 1-100.096 0V516.309333c-169.813333-17.408-300.373333-121.728-300.373333-247.808C153.898667 130.261333 310.784 18.218667 504.32 18.218667s350.421333 112.085333 350.421333 250.282666c0 126.122667-130.56 230.442667-300.373333 247.808v102.656h100.138667a50.048 50.048 0 0 1 0 100.096H554.368zM504.32 368.64a100.138667 100.138667 0 1 0 0-200.234667 100.138667 100.138667 0 1 0 0 200.234667z\" fill=\"#bfbfbf\" p-id=\"4528\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/vcode.svg
// module id = 5FKC
// module chunks = 115